import { ReactComponent as Close } from 'assets/icons/icon-close.svg';

export default Close;
